import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=2ee196c4&"
import script from "./DocumentsList.vue?vue&type=script&lang=ts&"
export * from "./DocumentsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports